export default "__VITE_ASSET__64e02b34__"